// import useThemeStore from "@hooks/zustand/Theme/useThemeStore";//zustand
import useThemeStore from "@/shared/store/useThemeStore";
import { THEMES } from "@shared-types/themes";
import clsx from "clsx";
import { useMemo } from "react";
import ErrorText from "./ErrorText";

interface InputWithTitleAndChecksProps {
  placeholder: string;
  placeholderColor?: string;
  disabled?: boolean;
  name?: string;
  title?: string;
  onChange: (e: React.SyntheticEvent) => void;
  value?: string;
  errorMessage?: string | null;
  iconRight?: string;
  type?: string;
  className?: string;
  inputClassName?: string;
  styleType?: string;
}

export default function InputWithTitleAndChecks({
  placeholder = "",
  placeholderColor,
  disabled = false,
  name,
  title = "",
  onChange,
  value = "",
  errorMessage = "",
  iconRight = "",
  type = "text",
  className,
  inputClassName = "",
  styleType,
  ...inputProps
}: InputWithTitleAndChecksProps) {
  const htmlFor = title
    ? `${title.replace(/\s/g, "-").toLowerCase()}-input`
    : "";

  let isSleek = styleType === "sleek" ? true : false;
  let isSquare = styleType === "square" ? true : false;

  const { theme } = useThemeStore();

  const uiOptions = useMemo(() => {
    if (theme === THEMES["02"])
      return {
        labelClass: "text-sapphire01 text-sm font-normal",
      };
    return {
      labelClass: "text-slate01 text-sm font-semibold",
    };
  }, [theme]);

  return (
    <div className={className}>
      {title && (
        <label
          htmlFor={htmlFor ? htmlFor : ""}
          className={uiOptions.labelClass}
        >
          {title}
        </label>
      )}
      <div className="mt-3 flex flex-row items-center ">
        <input
          id={htmlFor ? htmlFor : ""}
          type={type}
          value={value}
          name={name}
          className={clsx([
            "flex-1",
            "sm:-mr-7",
            "block",
            "w-full",
            inputClassName,
            !isSquare && "rounded",
            "text-slate01",
            isSleek && "text-base",
            "sm:text-sm",
            placeholderColor ?? "placeholder-slate03",
            "border",
            "border-grey-2",
            "focus:border-grey-4",
            "focus:outline-none",
            "focus:ring-0",
            (isSleek || isSquare) && "h-12",
            "px-4 py-2.5",
            isSleek && "rounded-lg",
          ])}
          placeholder={placeholder}
          onChange={(e) => onChange(e)}
          {...inputProps}
        />{" "}
        {/* <MdCheckCircle
          size={28}
          color={"#269A5A"}
          className={`relative left-9 hidden place-content-center place-self-center sm:inline-block ${
            iconRight ? "visible" : "invisible"
          }`}
        /> */}
      </div>
      <ErrorText errorMessage={errorMessage} showError={errorMessage !== ""} />
      {/* {errorMessage && (
      <label className="text-red mt-0.5 text-xs font-normal h-8">
        {errorMessage}
      </label>
    )} */}
    </div>
  );
}
